import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { LoaderCircle } from "lucide-react";
import { LandesseiteView } from "@/components/wahlkalender/LandesseiteView";
import { loadWahlkalenderDraft } from "@/lib/wahlkalender-landesseite.functions";
import { getLeadMagnetPage } from "@/lib/lead-magnets.functions";
import { WAHLKALENDER_MAGNET_SLUG } from "@/lib/wahlkalender-landesseite";

export const Route = createFileRoute("/_admin/admin/wahlkalender_/vorschau/$bundesland")({
  head: () => ({ meta: [
    { title: "Landesseiten-Entwurf – creategy" },
    { name: "description", content: "Geschützte Vorschau der Wahlkalender-Landesseite." },
    { property: "og:title", content: "Landesseiten-Entwurf – creategy" },
    { property: "og:description", content: "Geschützte Vorschau der Wahlkalender-Landesseite." },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary" },
    { name: "robots", content: "noindex, nofollow" },
  ] }),
  component: DraftPreview,
});

function DraftPreview() {
  const { bundesland } = Route.useParams();
  const load = useServerFn(loadWahlkalenderDraft);
  const { data, isPending, error } = useQuery({
    queryKey: ["wahlkalender", "draft", bundesland],
    queryFn: async () => {
      const page = await load({ data: { slug: bundesland } });
      if (!page) throw new Error("Entwurf nicht gefunden.");
      const magnet = await getLeadMagnetPage({ data: { slug: WAHLKALENDER_MAGNET_SLUG } });
      return { ...page, magnet };
    },
  });
  if (isPending) return <p role="status" className="flex min-h-64 items-center justify-center gap-2"><LoaderCircle className="h-5 w-5 animate-spin" /> Vorschau wird geladen …</p>;
  if (error || !data) return <p role="alert" className="p-8">Vorschau nicht verfügbar.</p>;
  return <LandesseiteView {...data} />;
}